import Command from './Command';

export default class ClearCommand extends Command {
  // eslint-disable-next-line no-useless-constructor
  constructor(public id: number, public sceneId: number) {
    super(id, sceneId);
  }
}
